<div class="container-fluid main-page main-page-padding">
    <div class="page-title">
        <h2 class="page-header">Daily Game</h2>
    </div>
    <div class="page-content">
        <div *ngIf="loading" class="text-center">
            <app-loading-wbac-animation></app-loading-wbac-animation>
        </div>
        <div *ngIf="!loading" class="container-fluid">
            <div class="section">
                <div class="row results">
                    <div class="col-2 attempt-label">Make</div>
                    <div class="col attempt-box"><div [ngClass]="{'correct': getResult(0, true) > 0, 'wrong': getResult(0, true) < 0}"></div></div>
                    <div class="col attempt-box"><div [ngClass]="{'correct': getResult(1, true) > 0, 'wrong': getResult(1, true) < 0}"></div></div>
                    <div class="col attempt-box"><div [ngClass]="{'correct': getResult(2, true) > 0, 'wrong': getResult(2, true) < 0}"></div></div>
                    <div class="col attempt-box"><div [ngClass]="{'correct': getResult(3, true) > 0, 'wrong': getResult(3, true) < 0}"></div></div>
                    <div class="col attempt-box"><div [ngClass]="{'correct': getResult(4, true) > 0, 'wrong': getResult(4, true) < 0}"></div></div>
                    <div class="col attempt-box"><div [ngClass]="{'correct': getResult(5, true) > 0, 'wrong': getResult(5, true) < 0}"></div></div>
                    <div class="col attempt-box"><div [ngClass]="{'correct': getResult(6, true) > 0, 'wrong': getResult(6, true) < 0}"></div></div>
                    <div class="col attempt-box"><div [ngClass]="{'correct': getResult(7, true) > 0, 'wrong': getResult(7, true) < 0}"></div></div>
                    <div class="col attempt-box"><div [ngClass]="{'correct': getResult(8, true) > 0, 'wrong': getResult(8, true) < 0}"></div></div>
                    <div class="col"></div>
                </div>
                <div class="row">
                    <div class="col-2 attempt-label">Model</div>
                    <div class="col attempt-box"><div [ngClass]="{'correct': getResult(0, false) > 0, 'wrong': getResult(0, false) < 0}"></div></div>
                    <div class="col attempt-box"><div [ngClass]="{'correct': getResult(1, false) > 0, 'wrong': getResult(1, false) < 0}"></div></div>
                    <div class="col attempt-box"><div [ngClass]="{'correct': getResult(2, false) > 0, 'wrong': getResult(2, false) < 0}"></div></div>
                    <div class="col attempt-box"><div [ngClass]="{'correct': getResult(3, false) > 0, 'wrong': getResult(3, false) < 0}"></div></div>
                    <div class="col attempt-box"><div [ngClass]="{'correct': getResult(4, false) > 0, 'wrong': getResult(4, false) < 0}"></div></div>
                    <div class="col attempt-box"><div [ngClass]="{'correct': getResult(5, false) > 0, 'wrong': getResult(5, false) < 0}"></div></div>
                    <div class="col attempt-box"><div [ngClass]="{'correct': getResult(6, false) > 0, 'wrong': getResult(6, false) < 0}"></div></div>
                    <div class="col attempt-box"><div [ngClass]="{'correct': getResult(7, false) > 0, 'wrong': getResult(7, false) < 0}"></div></div>
                    <div class="col attempt-box"><div [ngClass]="{'correct': getResult(8, false) > 0, 'wrong': getResult(8, false) < 0}"></div></div>
                    <div class="col"></div>
                </div>
            </div>
            <div class="section row">
                <div class="col-6 picture-box">
                    <div class="image">
                        <img class="game-image" [src]="imageUrl" />
                        <div class="blocker visible a1" [ngClass]="{'selected': selectedArea === 0}"></div>
                        <div class="blocker visible a2" [ngClass]="{'selected': selectedArea === 1}"></div>
                        <div class="blocker visible a3" [ngClass]="{'selected': selectedArea === 2}"></div>
                        <div class="blocker visible b1" [ngClass]="{'selected': selectedArea === 3}"></div>
                        <div class="blocker visible b2" [ngClass]="{'selected': selectedArea === 4}"></div>
                        <div class="blocker visible b3" [ngClass]="{'selected': selectedArea === 5}"></div>
                        <div class="blocker visible c1" [ngClass]="{'selected': selectedArea === 6}"></div>
                        <div class="blocker visible c2" [ngClass]="{'selected': selectedArea === 7}"></div>
                        <div class="blocker visible c3" [ngClass]="{'selected': selectedArea === 8}"></div>
                    </div>
                </div>
                <div *ngIf="gameState.spinning" class="col-4 button-box">
                    <div class="plate">
                        <button class="pushable" (click)="stop()">
                            <span class="front"></span>
                        </button>
                    </div>
                    <div class="button-text">Push button to stop</div>
                </div>
                <div *ngIf="gameState.spinning" class="col-2"></div>
                <div *ngIf="!gameState.spinning" class="col-6">
                    <form class="centeredForm" [formGroup]="gameForm" (ngSubmit)="attemptToWin()">
                        <div class="input-field">
                            <div *ngIf="isMakeLoading">
                                <input class="empty-select form-control" type="text" />
                                <span class="loading-anim"></span>
                            </div> 
                            <select [hidden]="isMakeLoading" (change)="makeChange($event)" id="make" formControlName="make" class="form-control">
                                <option label="Make" disabled></option>
                                <option [value]="make.key" *ngFor="let make of manufacturerList | async">
                                {{ make.value }}
                                </option>
                            </select>
                        </div>
                        <div class="input-field">
                            <div *ngIf="isModelLoading">
                                <input class="empty-select form-control" type="text" />
                                <span class="loading-anim"></span>
                            </div>
                            <select [hidden]="isModelLoading" (change)="modelChange($event)" id="model" formControlName="model" class="form-control">
                                <option label="Model" disabled></option>
                                <option [value]="model.key" *ngFor="let model of modelList | async">
                                {{ model.value }}
                                </option>
                            </select>
                        </div>
                        <button [ngClass]="{'active':gameForm.valid, 'invalid':!gameForm.valid, 'loading': loading}" type="submit" class="modal-button confirm-btn" [disabled]="!gameForm.valid || loading">
                            Submit
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
